import React from 'react';

import { Card, SimpleGrid, Skeleton, Stack, Text } from '@mantine/core';

import DistributionOfSHMPlot from './DistributionOfSHMPlot';
import DistributionOfSHMViolinPlot from './DistributionOfSHMViolinPlot';
import { LoadingContainer } from '../common/LoadingContainer';
import type { BinnedData, ShmDistributionData } from '../generated/generatedOpenAPI';

interface SomaticHypermutationProps {
  shmDistributionData: ShmDistributionData | undefined;
  shmViolinData: BinnedData | undefined;
  isLoading?: boolean;
}

export default function SomaticHypermutation({ shmDistributionData, shmViolinData, isLoading }: SomaticHypermutationProps) {
  if (isLoading) {
    return (
      <Card withBorder>
        <LoadingContainer height={300} />
      </Card>
    );
  }

  if (!shmDistributionData) {
    return (
      <Card withBorder>
        <Skeleton height={300} />
      </Card>
    );
  }

  return (
    <Card withBorder>
      <Stack gap="xl">
        <Text>Somatic Hypermutation</Text>
        <SimpleGrid cols={shmViolinData ? 2 : 1}>
          <DistributionOfSHMPlot shmDistributionData={shmDistributionData} />
          {shmViolinData && <DistributionOfSHMViolinPlot shmViolinData={shmViolinData} />}
        </SimpleGrid>
      </Stack>
    </Card>
  );
}
